/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonAuthUserInfo,
    JsonAuthUserInfoFromJSON,
    JsonAuthUserInfoFromJSONTyped,
    JsonAuthUserInfoToJSON,
} from './JsonAuthUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonAuthUserInfo
 */
export interface ApiResultOfJsonAuthUserInfo {
    /**
     * 
     * @type {JsonAuthUserInfo}
     * @memberof ApiResultOfJsonAuthUserInfo
     */
    data?: JsonAuthUserInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAuthUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonAuthUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAuthUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAuthUserInfo
     */
    result?: ApiResultOfJsonAuthUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonAuthUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonAuthUserInfoFromJSON(json: any): ApiResultOfJsonAuthUserInfo {
    return ApiResultOfJsonAuthUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonAuthUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonAuthUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonAuthUserInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonAuthUserInfoToJSON(value?: ApiResultOfJsonAuthUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonAuthUserInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

